import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <div className="footer-box">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-5">
                            <h1 className="footer-text-top">Send App Link</h1>
                            <form action className="">
                                <div className='form-box-inputs'>
                                    <input type="number" defaultValue={+1} className="phone-code" />
                                    <input type="number" placeholder="Enter phone number" className="phone-number" />
                                </div>

                                <div className='gap-top-footer'>
                                    <button className='btn btn-primary' type='submit'>Send</button>
                                </div>
                            </form>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4">
                            <h1 className="footer-text-top">Social Media Link</h1>
                            <div className="social-links">
                                <a href="#">
                                    <i className="fa-brands fa-instagram instagram-icon" />
                                </a>
                                <a href="#">
                                    <i className="fa-brands fa-facebook-f facebook-icon" />
                                </a>
                                <a href="#">
                                    <i className="fa-brands fa-x-twitter twiter-icon"></i>
                                </a>
                                <a href="#">
                                    <i className="fa-brands fa-linkedin-in linkedin-icon" />
                                </a>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-3">
                            <h1 className="footer-text-top">Quick Link</h1>
                            <ul className="footer-links">
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to='/terms-and-conditions'>Terms and Conditions</Link></li>
                                <li><Link to="/about-us">About Us</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                                <li><a href="#">Sitemap</a></li>
                            </ul>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-4">
                            <h1 className="footer-text-top">Popular Places</h1>
                            <ul className="footer-links">
                                <li><a href="#">Los Angeles</a></li>
                                <li><a href="#">Miama</a></li>
                                <li><a href="#">Las Vegas</a></li>
                                <li><a href="#">New York</a></li>
                                <li><a href="#">Sant Diago</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer